export function formatKoreanNumber(num: number): string {
  if (num === 0) return '0'; // 0이면 그대로 반환

  const isNegative = num < 0;
  num = Math.abs(num); // 절대값 변환

  if (num < 10000) return (isNegative ? '-' : '') + num.toString(); // 1만 미만은 그대로 반환

  const units = ['', '만', '억', '조'];
  let result = '';
  let unitIndex = 0;

  while (num > 0) {
    const part = num % 10000;
    if (part > 0) {
      let partStr = part.toString();
      if (unitIndex > 0) {
        partStr = (part === 1 ? '1' : part) + units[unitIndex];
      }
      result = partStr + result;
    }
    num = Math.floor(num / 10000);
    unitIndex++;
  }

  return (isNegative ? '-' : '') + result;
}
